import { gql } from '@apollo/client'
import { SABRE_PACKAGING_FRAGMENT } from './PackagingFragment'
import { IMAGE_FRAGMENT } from './ImageFragment'
import { SABRE_MANUFACTURER_FRAGMENT } from './ManufacturerFragment'

/**
 * Optimized fragment for product search that includes only the fields needed for the search results
 */
export const SABRE_PRODUCT_SEARCH_FRAGMENT = gql`
  fragment ProductSearch on Product {
    id
    upcA
    upcE
    name
    preferredName
    packagingName
    isActive
    marketingImageUrl
    verifiedBy
    commonName {
      id
      name
    }
    brand {
      id
      name
    }
    packaging {
      ...Packaging
    }
    images {
      ...Image
    }
    manufacturer {
      ...Manufacturer
    }
  }
  ${SABRE_PACKAGING_FRAGMENT}
  ${IMAGE_FRAGMENT}
  ${SABRE_MANUFACTURER_FRAGMENT}
`
